import React from 'react';
import { Box, Typography } from '@mui/material';
import ScrollFadeWrapper from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import {
  SEO_SUBJECT_EXPLAINER_BLUE,
  SEO_SUBJECT_EXPLAINER_YELLOW,
  SeoSubjectExplainerCard,
} from './SeoSubjectExplainerShared';
import Image from '../../Image/Image';

const SeoSubjectExplainerMobileComponent = ({ data }) => {
  if (!data) return null;

  const { title, description, icon, footer, cards = [] } = data;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        boxSizing: 'border-box',
        px: '16px',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '100%',
          backgroundColor: SEO_SUBJECT_EXPLAINER_BLUE,
          borderRadius: '36px',
          boxSizing: 'border-box',
          padding: '32px 24px 36px',
          mb: '24px',
        }}
      >
        <Box
          sx={{
            width: '124px',
            height: '124px',
            borderRadius: '28px',
            backgroundColor: SEO_SUBJECT_EXPLAINER_YELLOW,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: '28px',
          }}
        >
          <Image
            width={60}
            height={60}
            src={icon}
            alt="icon graphic"
            aria-hidden="true"
            sx={{
              width: '60px',
              height: '60px',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Box>

        <Typography
          component="h2"
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 700,
            fontSize: '2.25rem',
            lineHeight: '2.5rem',
            letterSpacing: '-0.04em',
            color: '#FFFFFF',
            whiteSpace: 'pre-line',
            mb: '20px',
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: '1.125rem',
            lineHeight: '1.625rem',
            letterSpacing: '-0.02em',
            color: '#FFFFFF',
            whiteSpace: 'pre-line',
          }}
        >
          {description}
        </Typography>

        {footer ? (
          <Typography
            sx={{
              mt: '24px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: '0.9375rem',
              lineHeight: '1.375rem',
              letterSpacing: '-0.02em',
              color: 'rgba(255,255,255,0.9)',
              whiteSpace: 'pre-line',
            }}
          >
            {footer}
          </Typography>
        ) : null}
      </Box>

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        {cards.map((card, index) => (
          <ScrollFadeWrapper
            key={card?.title || index}
            delay={index * 0.1}
            variant="text"
          >
            <SeoSubjectExplainerCard
              card={card}
              index={index}
              isDesktop={false}
            />
          </ScrollFadeWrapper>
        ))}
      </Box>
    </Box>
  );
};

export default SeoSubjectExplainerMobileComponent;
